<template>
  <div id="uploadbox">
    <input type="file" v-show="false" @change="input1change" ref="fileName1" />
    <input type="file" v-show="false" @change="input2change" ref="fileName2" />
    <input type="file" v-show="false" @change="input3change" ref="fileName3" />
    <input type="file" v-show="false" @change="input4change" ref="fileName4" />
    <input type="file" v-show="false" @change="input5change" ref="fileName5" />
    <input type="file" v-show="false" @change="input6change" ref="fileName6" />
    <input type="file" v-show="false" @change="input7change" ref="fileName7" />
    <input type="file" v-show="false" @change="input8change" ref="fileName8" />
    <input type="file" v-show="false" @change="input9change" ref="fileName9" />
    <div class="header">
      <span>预约科目</span>
    </div>
    <div class="section">
      <div class="title">预约考试等级 <span class="red">*</span></div>
      <el-select class="select" v-model="studentDetails.examRank" placeholder="请选择">
        <el-option
          v-for="item in levelList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <el-checkbox-group class="checkbox" v-model="selectSubjectList">
        <el-checkbox
          style="zoom:110%;margin-bottom:5px"
          v-for="(item,index) in subjectArray" 
          :label="item.name"
          :checked="checked"  
          @change="checked=!checked" 
          :disabled="updateTimeAuthority"
          :key="index">
          {{item.name}}（{{item.price}}元）
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <template v-if="isSelectTheory && updateTimeAuthority">
      <div class="header">
        <span>预约理论考试</span>
      </div> 
      <div class="section examTimePlaceholder"> 
        <div class="title">预约考试地点 <span class="red">*</span></div>
        <el-select class="select" v-model="theoryAddress" placeholder="请选择考试地点">
          <el-option
            v-for="(item,index) in examAddress"
            :key="index"
            :label="item.examAddressName"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="title">预约考试时间 <span class="red">*</span></div>
        <el-cascader
          class="examTimePlaceholder"
          :placeholder="theoryExamTimeDefault"
          style="width:100%"
          separator=' '
          popper-class="train-tree"
          v-model="theorySelectExamTimeList"
          :options="theoryExamTimeList"
        >
        </el-cascader>
      </div>
    </template>
    <template v-if="isSelectOpera && updateTimeAuthority">
      <div class="header">
        <span>预约实操考试</span>
      </div> 
      <div class="section examTimePlaceholder"> 
        <div class="title">预约考试地点 <span class="red">*</span></div>
        <el-select class="select" v-model="operaAddress" placeholder="请选择考试地点">
          <el-option
            v-for="(item,index) in examAddress"
            :key="index"
            :label="item.examAddressName"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="title">预约考试时间 <span class="red">*</span></div>
        <el-cascader
          :placeholder="operaExamTimeDefault"
          style="width:100%"
          separator=' '
          popper-class="train-tree"
          v-model="operaSelectExamTimeList"
          :options="operaExamTimeList"
        >
        </el-cascader>
      </div>
    </template>
    <div class="header">
      <span>预约信息</span>
    </div>  
    <div class="section">    
      <div class="title">姓名 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.examName" placeholder="请输入姓名"></el-input>

      <div class="title">证件类型 <span class="red">*</span></div>
      <el-select class="select" v-model="studentDetails.examCardStatus" placeholder="请选择">
        <el-option
          v-for="(item,index) in idTypeList"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <div class="title">证件号码 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.examCard" placeholder="请输入证件号码"></el-input>
    
      <div class="title">出生日期</div>
      <div class="block date_picker">
        <el-date-picker
          v-model="studentDetails.birthdate"
          type="date"
          placeholder="选择日期"
          >
        </el-date-picker>
      </div>

      <div class="title">性别 <span class="red">*</span></div>
      <div class="radio">
        <el-radio v-model="studentDetails.examSex" label="男">男</el-radio>
        <el-radio v-model="studentDetails.examSex" label="女">女</el-radio>
      </div>

      <div class="title">民族</div>
      <el-select class="select" v-model="studentDetails.nation" placeholder="请选择">
        <el-option
          v-for="(item,index) in nationList"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <div class="title">政治面貌 </div>
      <el-select class="select" v-model="studentDetails.politicsstatus" placeholder="请选择">
        <el-option
          v-for="(item,index) in politicsList"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <div class="title">所属群体<span class="red">*</span></div>
      <el-select class="select" v-model="studentDetails.referenceGroup" placeholder="请选择">
        <el-option
          v-for="(item,index) in groupList"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <div class="title">工作单位 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.workunit" placeholder="请输入工作单位"></el-input>

      <div class="title">职业年限 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.term" placeholder="请输入职业年限"></el-input>

      <div class="title">现居省份 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.currentaddress" placeholder="请输入居住省份"></el-input>

      <div class="title">现居市区 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.downtown" placeholder="请输入居住市区"></el-input>

      <div class="title">邮政编码</div>
      <el-input class="input" v-model="studentDetails.postalcode" placeholder="请输入邮政编码"></el-input>

      <div class="title">从事职业</div>
      <el-input class="input" v-model="studentDetails.engineer" placeholder="请输入从事职业"></el-input>

      <div class="title">参加工作日期</div>
      <div class="block date_picker">
        <el-date-picker
          v-model="studentDetails.dateofentry"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </div>

      <div class="title">身份信息</div>
      <el-input class="input" v-model="studentDetails.identity" placeholder="请输入身份信息"></el-input>

      <div class="title">职业 <span class="red">*</span></div>
      <el-select class="select" v-model="studentDetails.profession" placeholder="请选择">
        <el-option
          v-for="(item,index) in professionList"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <div class="title">鉴定分类 <span class="red">*</span></div>
      <el-select class="select" v-model="studentDetails.classification" placeholder="请选择">
        <el-option
          v-for="(item,index) in classificationList"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <div class="title">手机号码 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.examPhone" placeholder="请输入手机号码"></el-input>
    </div>

    <div class="header">
      <span>预约条件</span>
    </div>  
    <div class="section"> 
      <div class="title">申报条件 <span class="red">*</span></div>
      <el-select class="select" v-model="studentDetails.acceptance" placeholder="请选择">
        <el-option
          v-for="(item,index) in acceptanceList"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <div class="title">文化程度 <span class="red">*</span></div>
      <el-select class="select" v-model="studentDetails.examRecord" placeholder="请选择">
        <el-option
          v-for="(item,index) in educationList"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <div class="title">毕业时间 <span class="red">*</span></div>
      <div class="block date_picker">
        <el-date-picker
          v-model="studentDetails.examGetTime"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </div>

      <div class="title">毕业学校 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.schoolTag" placeholder="请输入毕业学校"></el-input>
    
      <div class="title">上传毕业证书 <span class="red">*</span></div>
      <div class='remark'>（扫描件PDF格式：小于1M，以身份证号命名）</div>
      <div class="input_file flex_box">
        <file-box
          @bindup="diplomaFile"
          headert="毕业证书"
          :mainup="studentDetails.diploma"
          fileName="毕业证书.PDF">
        </file-box>
        <file-box-example
          headert="示例"
          imgName="certificate"
        ></file-box-example>
      </div>

      <div class="title">上传社保记录 </div>
      <div class='remark'>（扫描件PDF格式：小于1M，以身份证号命名）</div>
      <div class="input_file flex_box">
        <file-box
          @bindup="socialSecurityFile"
          headert="社保记录"
          :mainup="studentDetails.socialSecurity"
          fileName="社保记录.PDF">
        </file-box>
        <file-box-example
          headert="示例"
          imgName="social"
        ></file-box-example>
      </div>

      <div class="title">上传工作经验及证明文件 <span class="red">*</span></div>
      <div class='remark'>（扫描件PDF格式：小于1M，以身份证号命名）</div>
      <div class="input_file flex_box">
        <file-box
          @bindup="certificateFile"
          headert="工作证明"
          :mainup="studentDetails.certificate"
          fileName="工作证明.PDF">
        </file-box>
        <file-box-example
          headert="示例"
          imgName="experience"
        ></file-box-example>
      </div>

      <div class="title">上传身份证（正反面）<span class="red">*</span></div>
      <div class='remark'>（扫描件PDF格式：扫描放在一张A4纸上，小于1M，以身份证号命名）</div>
      <div class="input_file flex_box">
        <file-box
          @bindup="cardpositiveFile"
          headert="身份证"
          :mainup="studentDetails.cardpositive"
          fileName="身份证.PDF">
        </file-box>
        <file-box-example
          headert="示例"
          imgName="idCard"
        ></file-box-example>
      </div>

      <div class="title">上传本人证件照 <span class="red">*</span></div>
      <div class='remark'>（2寸白底照：3.5cm*5.3cm。电子版jpg格式：像素306*378，小于200K，以身份证号命名）</div>
      <div class="input_file flex_box">
        <file-box
          @bindup="examIdentificationImgFile"
          headert="本人证件照"
          :mainup="studentDetails.examIdentificationImg"
          fileName="本人证件照.JPG">
        </file-box>
        <file-box-example
          headert="示例"
          imgName="personCard"
        ></file-box-example>
      </div>

      <div class="title">上传报名申报表 <span class="red">*</span></div>
      <div class='remark'>（扫描件PDF格式：小于1M，以身份证号命名）</div>
      <div class="input_file flex_box">
        <file-box
          @bindup="registrationFormFile"
          headert="报名申报表"
          :mainup="studentDetails.registrationForm"
          fileName="报名申报表.PDF">
        </file-box>
        <file-box-example
          headert="示例"
          imgName="declare"
        ></file-box-example>
      </div>

      <div class="title">上传学信网验证报告 <span class="red">*</span></div>
      <div class='remark'>（扫描件PDF格式：小于1M，以身份证号命名）</div>
      <div class="input_file flex_box">
        <file-box
          @bindup="xuexinelectronicFile"
          headert="学信网验证报告"
          :mainup="studentDetails.xuexinelectronic"
          fileName="学信网验证报告.PDF">
        </file-box>
        <file-box-example
          headert="示例"
          imgName="xuexin"
        ></file-box-example>
      </div>
      <div class="title">上传职业技能/职业资格/职称证书</div>
      <div class='remark'>（扫描件PDF格式：小于1M，以身份证号命名）</div>
      <div class="input_file flex_box">
        <file-box
          @bindup="graduateFile"
          headert="证书"
          :mainup="studentDetails.completionCertificate"
          fileName="职业技能/职业资格/职称证书.PDF">
        </file-box>
        <file-box-example
          headert="示例"
          imgName="graduate"
        ></file-box-example>
      </div>

      <div class="title">证书邮寄地址 <span class="red">*</span></div>
      <el-input class="input" v-model="studentDetails.examCertificate" placeholder="请输入证书邮寄地址"></el-input>

      <div class="title">报名备注</div>
      <el-input class="input" v-model="studentDetails.remark" placeholder="请输入报名备注"></el-input>
    </div>

    <template>
      <van-dialog v-model="tipFlag" title="提示" confirmButtonColor="#54B0FB" :show-confirm-button="false">
        <div class="content"> 
          {{tipText}}
        </div>
        <van-divider></van-divider>
        <div class="confirm">
          <span @click="tipFlag=false">确定</span>
        </div>
      </van-dialog>
    </template>

    <div class="confirm_box" v-if="isReview">
      <van-button
        class="leftb"
        type="info"
        @click="confirmSubmit()"
        >确认修改信息
      </van-button>
    </div>
  </div>
</template>

<script>
import nationList from '@/assets/json/nation.json'
import idTypeList from '@/assets/json/idType.json'
import politicsList from '@/assets/json/politics.json'
import groupList from '@/assets/json/group.json'
import educationList from '@/assets/json/education.json'
import fileBoxExample from '@/view/reserve/fileUploadExample.vue'
import fileBox from "@/components/filebox.vue";
export default {
  name: "review",
  components:{
    fileBox,
    fileBoxExample
  },
  data() {
    return {
      checked:false,
      levelList: [],         //考试等级
      idTypeList,            //身份证类型
      nationList,            //民族
      politicsList,          //政治面貌
      groupList,             //所属群体
      professionList: ['4140202-健康管理师-三级'],  //所属职业
      classificationList: ['初次鉴定','晋级'],  //鉴定分类
      acceptanceList: ['14412-健康管理师三级-其他'],  //申报条件
      educationList,         //文化程度  
      studentDetails: {},
      selectSubjectList:[], //选择的科目
      examAddress: [], //考试地点数据
      theoryAddress: '', //理论考试地点
      operaAddress: '',  //实操考试地点
      theoryExamTimeList: [], //理论考试时间
      theoryExamTimeDefault: '请选择考试时间',
      theorySelectExamTimeList: [],
      theorySelectExamTime: '',  //理论时间id
      copyTheorySelectExamTime: '',
      operaExamTimeList: [], //实操考试时间
      operaExamTimeDefault: '请选择考试时间',
      operaSelectExamTimeList: [],
      operaSelectExamTime:'',    //实操时间id
      copyOperaSelectExamTime: '',
      subjectArray: [],
      tipFlag: false,
      tipText: ''
    }
  },
  computed: {
    isReview: function() {
      return this.$route.params.type === 'review'
    },
    isSelectTheory: function() {
      return this.selectSubjectList.includes('理论')
    },
    isSelectOpera: function() {
      return this.selectSubjectList.includes('实操')
    },
    updateTimeAuthority: function() {
      return Boolean(this.$route.query.isUpdateTime)
    }
  },
  created() {
    this.getLevelList()
    this.fetchDetails()
    this.getAddress()
  },
  watch: {
    theorySelectExamTimeList: {
      handler: function() {
        this.theorySelectExamTime = this.theorySelectExamTimeList[1]
      },
      deep:true
    },
    operaSelectExamTimeList: {
      handler: function() {
        this.operaSelectExamTime = this.operaSelectExamTimeList[1]
      },
      deep:true
    },
    'studentDetails.examRank': function() {
      this.getSubject()
    },
    theoryAddress: {
      handler:function(newValue,oldValue) {
        if(oldValue){
          this.theorySelectExamTimeList = []
          this.theoryExamTimeDefault = ''
        }
        this.fetchExamTime('theory',this.theoryAddress)
      },
      immediate: true
    },
    operaAddress: {
      handler: function(newValue,oldValue) {
        if(oldValue){
          this.operaSelectExamTimeList = []
          this.operaExamTimeDefault = ''
        }
        this.fetchExamTime('operation', this.operaAddress)
      },
      immediate: true
    }
  },
  methods: {
    getLevelList: function() {
      let params = {
        id: this.$route.params.id,
      }
      this.$http.get('/registration/level/list', {params}).then(res => {
        if(res.data.success) {
          this.levelList = res.data.data
        }
      })
    },
    getSubject: function() {
      let params = {
        examRank: this.studentDetails.examRank,
        id: this.$route.params.id,
      }
      this.$http.get('/registration/subject/list', {params}).then(res => {
        if(res.data.success) {
          this.subjectArray = res.data.data
        }
      })
    },
    fetchDetails: function () {
      const params = {
        id: this.$route.params.id,
      }
      this.$http.get("registration/one", { params }).then((res) => {
        if (res.data.success) {
          let data = res.data.data
          this.studentDetails = data.info
          if(data.theory && data.theory.day){
            this.theoryAddress = data.theory.addressId
            this.theorySelectExamTime = data.theory.examId
            this.copyTheorySelectExamTime = data.theory.examId
            this.theoryExamTimeDefault = data.theory.day + ' ' + data.theory.period
          }
          if(data.operation && data.operation.day){
            this.operaAddress = data.operation.addressId
            this.operaSelectExamTime = data.operation.examId
            this.copyOperaSelectExamTime = data.operation.examId
            this.operaExamTimeDefault = data.operation.day + ' ' + data.operation.period
          }
          if(this.studentDetails.subject){
            this.selectSubjectList = this.studentDetails.subject.split('，')
          }
        } else {
          console.log(err);
        }
      })
      .catch((err) => console.log(err));
    },
    getAddress: function() {    //获取考试地点
      this.$http.get("/registration/address").then(res => {
        if(res.data.success){
          this.examAddress = res.data.data
        }
      }).catch(() => {
        this.$message({
          message: "获取考试地点失败",
          type: "warning",
        })
      })
    },
    fetchExamTime: function(subject,addressId) {  //获取考试时间
      const params = {
        appraisalId: this.$route.query.appraisalId,
        addressId: addressId,
        subject: subject
      }
      let path = this.updateTimeAuthority ? '/examination/time' : '/registration/time'
      this.$http.get(path, {params}).then((res) => {
        if (res.data.success) {
          let list = res.data.data.timeList
          list.forEach(res => {
            res.value = res.label
            res.children.forEach(childRes =>{
              childRes.value = childRes.examId
              childRes.label = childRes.period + `（剩余${childRes.remainNumber < 0 ? 0 : childRes.remainNumber}人）`
              if(childRes.remainNumber <= 0 ){
                childRes.disabled = true
              }
            })
          })
          if(subject === 'theory'){
            this.theoryExamTimeList = list
          }else {
            this.operaExamTimeList = list
          }
        }else{
          this.$message({
            message: res.data.msg,
            type: "warning",
          })
        } 
      })
    },
    confirmSubmit: function() {
      this.studentDetails.subject = this.selectSubjectList.join('，')
      if(this.studentDetails.birthdate){
        this.studentDetails.birthdate = this.$moment(this.studentDetails.birthdate).format('yyyy-MM-DD')
      }
      if(this.studentDetails.dateofentry){
        this.studentDetails.dateofentry = this.$moment(this.studentDetails.dateofentry).format('yyyy-MM-DD')
      }
      if(this.studentDetails.examGetTime){
        this.studentDetails.examGetTime = this.$moment(this.studentDetails.examGetTime).format('yyyy-MM-DD')
      }
      let data = {
        ...this.studentDetails
      }
      let params = {
        itemJson: JSON.stringify(data),
        theAddressId: this.theoryAddress || '',
        theExamId: this.theorySelectExamTime || '',
        opeAddressId: this.operaAddress || '',
        opeExamId: this.operaSelectExamTime || ''
      }
      if(!this.selectSubjectList.length){
        this.$message({
          message: "请选择一个科目",
          type: "warning",
        })
        return false
      }
      if(this.isSelectTheory&&this.updateTimeAuthority) {
        if(!this.theoryAddress || !this.theorySelectExamTime){
          this.$message({
            message: "请完善信息",
            type: "warning",
          })
          return false
        }
      }else {
        params.theAddressId = ''
        params.theExamId = ''
      }
      if(this.isSelectOpera&&this.updateTimeAuthority) {
        if(!this.operaAddress || !this.operaSelectExamTime){
          this.$message({
            message: "请完善信息",
            type: "warning",
          })
          return false
        }
      }else {
        params.opeAddressId = ''
        params.opeExamId = ''
      }

      if (this.copyTheorySelectExamTime==params.theExamId) {
        params.theAddressId = ''
        params.theExamId = ''
      }
      if (this.copyOperaSelectExamTime==params.opeExamId) {
        params.opeAddressId = ''
        params.opeExamId = ''
      }
      this.$http.post("/registration/update", params).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "修改信息成功",
            type: "success",
          })
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        }else{
          this.tipText = res.data.msg || '修改信息失败'
          this.tipFlag = true
        }
      }).catch(() => {
        this.$message({
          message: "未知异常",
          type: "warning",
        })
      })
    },
    diplomaFile() {
      this.status = 1;
      this.$refs.fileName1.click();
    },
    socialSecurityFile() {
      this.status = 2;
      this.$refs.fileName2.click();
    },
    certificateFile() {
      this.status = 3;
      this.$refs.fileName3.click();
    },
    cardpositiveFile() {
      this.status = 4;
      this.$refs.fileName4.click();
    },
    examIdentificationImgFile() {
      this.status = 5;
      this.$refs.fileName5.click();
    },
    registrationFormImgFile() {
      this.status = 6;
      this.$refs.fileName6.click();
    },
    registrationFormFile() {
      this.status = 7;
      this.$refs.fileName7.click();
    },
    xuexinelectronicFile() {
      this.status = 8;
      this.$refs.fileName8.click();
    },
    graduateFile() {
      this.status = 9;
      this.$refs.fileName9.click();
    },
    input1change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.diploma = res.data[0].path;
          }
        }
      )
    },
    input2change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.socialSecurity = res.data[0].path;
          }
        }
      )
    },
    input3change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.certificate = res.data[0].path;
          }
        }
      )
    },
    input4change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.cardpositive = res.data[0].path;
          }
        }
      )
    },
    input5change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.examIdentificationImg = res.data[0].path;
          }
        }
      )
    },
    input6change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.registrationFormImg = res.data[0].path;
          }
        }
      )
    },
    input7change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.registrationForm = res.data[0].path;
          }
        }
      )
    },
    input8change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.xuexinelectronic = res.data[0].path;
          }
        }
      )
    },
    input9change(event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
			this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.studentDetails.completionCertificate = res.data[0].path;
          }
        }
      )
    },
    goback() {
      this.$router.push({ path: `/examore` });
    },
  }
}
</script>

<style lang='less' scoped>
*{
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none; 
}
#uploadbox {
  height: 100vh;
  background: white;
  overflow: auto;
}
.confirm_box {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}
#uploadbox .leftb {
  width: 100%;
  height: 80px;
  font-size: 34px;
}
.header {
  height: 100px;
  padding-left: 30px;
  background: #EEEEEE;
  line-height: 100px;
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 20px;
}
.section {
  box-sizing: border-box;
  width: 100%;
  padding: 20px 30px
}
.title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
}
.red{
  color: red;
}
/* el-ui */
.select,
.input{
  width: 100%;
  height: 30px;
  margin-bottom: 70px;
}
.checkbox {
  display: flex;
  flex-direction: column;
  width: 30px;
}
.radio,
.date_picker,
.input_file{
  margin-bottom: 20px;
}
.remark{
  color: #BDBDBD;
  font-size: 18px;
  margin: -15px 0 20px 0;
}
.flex_box{
  display: flex;
  justify-content: space-between;
}
.content{
  padding:30px 60px;
  font-size: 32px;
}
.confirm{
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2196F3;
  padding-bottom: 16PX;
  span{
    cursor: pointer;
  }
}
::v-deep .van-dialog__header {
  font-size: 20PX;
  font-weight: 500;
}
</style>
<style lang='less'>
.train-tree{
  .el-cascader-node{
    padding: 0 !important;
  }
  .el-cascader-menu{
    min-width: 155px !important;
  }
  .el-icon-check{
    display: none;
  }
}
.examTimePlaceholder .el-input__inner::placeholder{
  color:rgba(0, 0, 0, 0.685) !important;
}
</style>